import { cn } from "@/tiptap/lib/tiptap-utils"

export const HUDU_ICON_BUTTON_CLASS = "button button--icon button--unfilled"

export function huduIconButtonClass(className) {
  return cn(HUDU_ICON_BUTTON_CLASS, className)
}
